export const BaiduUserTypeEnum = {
    BAIDU_MANAGER: 'baiduManager',
    BAIDU_COMMON: 'baiduCommon'
}

export const CustomerUserTypeEnum = {
    CUSTOMER_MANAGER: 'customerManager',
    CUSTOMER_COMMON: 'customerCommon'
}
export const UserTypeEnum = {
    ...BaiduUserTypeEnum,
    ...CustomerUserTypeEnum
};

export const UserTypeNameEnum = {
    [UserTypeEnum.BAIDU_MANAGER]: '百度管理员',
    [UserTypeEnum.BAIDU_COMMON]: '百度用户',
    [UserTypeEnum.CUSTOMER_MANAGER]: '企业管理员',
    [UserTypeEnum.CUSTOMER_COMMON]: '企业用户'
};

export const UserTypeCustomerNameEnum = {
    [UserTypeEnum.CUSTOMER_MANAGER]: '管理员',
    [UserTypeEnum.CUSTOMER_COMMON]: '普通用户'
};

export const AccountTypes = {
    UUAP: 'UUAP',
    PASSPORT: 'PASSPORT'
};